<ion-row class="wrapper" [ngClass]="{'shadow':withShadow}">
    <ion-col size="12" class="ion-justify-content-start" [ngClass]="{'with-progress': showProgress ||showCountrics}">
        <div class="top-wrapper">
            <div class="back" [routerLink]=" this.backPath ? this.backPath : '/home'">
                <img alt="back" src="assets/images/icons/arrow_left_green.svg"/>
                {{ 'btnBack'|transloco }}
            </div>

            <div class="page-title">
                {{ this.title }}

                <div *ngIf="showAchievementInfo" class="info" (click)="openModal('achievement')">

                    <img src="assets/images/icons/info24x24.svg" alt="info">
                </div>
            </div>

        </div>

        <div class="progress-wrapper" *ngIf="showProgress">
            <div class="info">

                <div class="title"> Average progress</div>


                <div class="details" (click)="openModal('progress')">{{ 'semiHeaderComp.progress'|transloco }}</div>


            </div>


            <div class="progress-wrapper-circle" *ngIf="avgProgress>0">

                <div class="progress-number">
                    {{ avgProgress }}
                </div>

                <round-progress class="progress"
                                [current]="avgProgress"
                                [max]="100"
                                [rounded]="true"
                                [stroke]="25"
                                [color]="'#3F403F'"
                                [background]="'#F2F2F2'"
                                [duration]="800"
                                [animation]="'easeInOutQuart'"
                                [animationDelay]="0"
                />


            </div>

            <div class="progress-wrapper-circle" *ngIf="avgProgress==0">

                <round-progress class="progress"
                                [max]="100"
                                [rounded]="true"
                                [stroke]="25"
                                [background]="'#CFCFCF'"
                                [duration]="800"
                                [animation]="'easeInOutQuart'"
                                [animationDelay]="0"
                />


            </div>

        </div>


        <div class="progress-wrapper" *ngIf="showCountrics">
            <div class="countrics-wrapper" [routerLink]="'/countrics'">
                <div class="info">
                    <div class="title">{{ 'semiHeaderComp.countrics'|transloco }}</div>
                    <div class="amount">{{ countrics }}</div>
                </div>
                <div class="image">
                    <img src="assets/images/student/cantrics.png" alt="money">
                </div>
            </div>

        </div>


    </ion-col>

</ion-row>
